export default "__VITE_ASSET__BQF64yDz__"